<mat-card>
  <mat-card-header>
    <h3>{{ 'PRODUCTION_ORDER.PRODUCTION_ORDER' | bmsTranslate: {count: 2} }}</h3>
    <div class="button-skeleton-wrapper standard-btn">
      <button mat-icon-button class="mat-icon-action-button-lg-with-border" [disabled]="planningItemsForm.disabled" (click)="addProductionOrders()">
        <mat-icon svgIcon="add"></mat-icon>
      </button>
      @if (showFixedSchedules) {
        <button mat-icon-button class="mat-icon-action-button-lg-with-border ml-16" [disabled]="planningItemsForm.disabled" (click)="addFixedSchedules()">
          <mat-icon svgIcon="schedule-24px"></mat-icon>
        </button>
      }
    </div>
  </mat-card-header>
  @if (planningItems.length > 0) {
    <mat-card-content>
      <ag-grid-angular class="ag-theme-vdw" [gridOptions]="gridOptions" [rowData]="planningItems" domLayout="autoHeight"></ag-grid-angular>
    </mat-card-content>
  }
</mat-card>
